import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35463244"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "tabs" };
const _hoisted_3 = { class: "tab_rows" };
const _hoisted_4 = {
    class: "tab_row",
    for: "chart"
};
const _hoisted_5 = {
    class: "tab_row",
    for: "order-book"
};
const _hoisted_6 = {
    class: "tab_row",
    for: "history"
};
import ChartZone from './ChartZone.vue';
import SmartPhoneOrderBook from './SmartPhoneOrderBook.vue';
import Loading from '@/materials/molecules/Loading.vue';
import History from './History.vue';
import { useStore } from '@/store/store';
import { useMessage } from '@/const/messages';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean },
        pair: null,
        base: null,
        quote: null,
        latestValue: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const { format, CHART_MESSAGES, ORDERBOOK_FIELDS, HISTORY_FIELDS } = useMessage();
        const showContent = ref('chart');
        const switchContent = (content) => {
            showContent.value = content;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("input", {
                            id: "chart",
                            type: "radio",
                            name: "tab_item",
                            checked: "",
                            onClick: _cache[0] || (_cache[0] = ($event) => (switchContent('chart')))
                        }),
                        _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(format)(_unref(CHART_MESSAGES).TITLE)), 1),
                        _createElementVNode("input", {
                            id: "order-book",
                            type: "radio",
                            name: "tab_item",
                            onClick: _cache[1] || (_cache[1] = ($event) => (switchContent('order-book')))
                        }),
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(format)(_unref(ORDERBOOK_FIELDS).TITLE)), 1),
                        _createElementVNode("input", {
                            id: "history",
                            type: "radio",
                            name: "tab_item",
                            onClick: _cache[2] || (_cache[2] = ($event) => (switchContent('history')))
                        }),
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(format)(_unref(HISTORY_FIELDS).TITLE)), 1)
                    ]),
                    (showContent.value === 'chart')
                        ? (_openBlock(), _createElementBlock("div", {
                            id: "chart_content",
                            class: _normalizeClass(["tab_content bg_color", _unref(store).state.chart.isFull ? 'fullscreen' : 'relative']),
                            key: props.pair
                        }, [
                            (_openBlock(), _createBlock(_Suspense, null, {
                                default: _withCtx(() => [
                                    _createVNode(ChartZone, {
                                        pair: props.pair
                                    }, null, 8, ["pair"])
                                ]),
                                fallback: _withCtx(() => [
                                    _createVNode(Loading)
                                ]),
                                _: 1
                            }))
                        ], 2))
                        : _createCommentVNode("", true),
                    (showContent.value === 'order-book')
                        ? (_openBlock(), _createElementBlock("div", {
                            id: "order_book_content",
                            class: "tab_content",
                            key: props.pair
                        }, [
                            (_openBlock(), _createBlock(_Suspense, null, {
                                default: _withCtx(() => [
                                    _createVNode(SmartPhoneOrderBook, {
                                        "is-auth": props.isAuth,
                                        quote: props.quote,
                                        base: props.base,
                                        "latest-value": props.latestValue,
                                        class: "bg"
                                    }, null, 8, ["is-auth", "quote", "base", "latest-value"])
                                ]),
                                fallback: _withCtx(() => [
                                    _createVNode(Loading)
                                ]),
                                _: 1
                            }))
                        ]))
                        : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createElementBlock("div", {
                        id: "history_content",
                        class: "tab_content bg_color",
                        key: props.pair
                    }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(History, {
                                    isAuth: props.isAuth
                                }, null, 8, ["isAuth"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ])), [
                        [_vShow, showContent.value === 'history']
                    ])
                ])
            ]));
        };
    }
});
